import servoList from './servoList.json'

/** 右嘴角机构与 IK 的 A/B 左右支座对应关系常为交叉，需交换分配到物理舵机序号 */
export function shouldSwapAnglesForTrajectory(trajectory) {
  if (!trajectory) return false
  if (trajectory.config?.swapAngles !== undefined) {
    return Boolean(trajectory.config.swapAngles)
  }
  const tn = trajectory.trajectoryName ?? trajectory.config?.trajectoryName
  if (tn === '右嘴角') return true
  if (trajectory.name === '右嘴角' || trajectory.config?.name === '右嘴角') return true
  return false
}

/** 仅 trajectory.config（如机械臂组件 props） */
export function shouldSwapAnglesForTrajectoryConfig(config) {
  if (!config) return false
  if (config.swapAngles !== undefined) return Boolean(config.swapAngles)
  if (config.trajectoryName === '右嘴角') return true
  if (config.name === '右嘴角') return true
  return false
}

/** 运动学臂 A 或 B 对应的物理舵机 id（与 getAngleForServoIndex 分配一致） */
export function getServoIdForKinematicArm(trajectory, arm) {
  const ids = trajectory.config?.ids
  if (!ids || ids.length < 2) return null
  const swap = shouldSwapAnglesForTrajectory(trajectory)
  if (arm === 'A') return swap ? ids[1] : ids[0]
  return swap ? ids[0] : ids[1]
}

export function getServoIdForKinematicArmFromConfig(config, arm) {
  const ids = config?.ids
  if (!ids || ids.length < 2) return null
  const swap = shouldSwapAnglesForTrajectoryConfig(config)
  if (arm === 'A') return swap ? ids[1] : ids[0]
  return swap ? ids[0] : ids[1]
}

export function resolveServoNameForId(servoId, servoVersions) {
  if (servoId == null) return null
  for (const version of servoVersions || []) {
    if (servoList[version]) {
      const info = servoList[version].find(s => s.id === servoId)
      if (info) return info.name
    }
  }
  return null
}

/** 物理舵机序号对应到 IK 的 A/B 角度（与 App.vue getAngleForServoIndex 一致） */
export function getKinematicAngleForPhysicalServoIndex(config, idx, angles) {
  const swap = shouldSwapAnglesForTrajectoryConfig(config)
  if (swap) return idx === 0 ? angles.servoB : angles.servoA
  return idx === 0 ? angles.servoA : angles.servoB
}

/** 将物理舵机角度写回 armConfig 的 servoA/servoB */
export function setKinematicArmFromPhysicalServoIndex(config, idx, angle, arm) {
  const swap = shouldSwapAnglesForTrajectoryConfig(config)
  if (idx === 0) {
    if (swap) arm.servoB = angle
    else arm.servoA = angle
  } else {
    if (swap) arm.servoA = angle
    else arm.servoB = angle
  }
}

/** 第 idx 路物理舵机对应运动学臂 A 或 B（与 getAngleForServoIndex 一致） */
export function getPhysicalServoKinematicArmLetterFromTrajectory(trajectory, idx) {
  const swap = shouldSwapAnglesForTrajectory(trajectory)
  if (idx === 0) return swap ? 'B' : 'A'
  return swap ? 'A' : 'B'
}

/** 运动学臂 A/B 在模型中的左右含义（逆运动学坐标：A 左支座、B 右支座） */
export function kinematicArmLetterHint(letter) {
  if (letter === 'A') return '左臂（左侧支座）'
  return '右臂（右侧支座）'
}

// 获取舵机A/B 标签（与运动学臂及角度分配一致）
export function getServoALabel(trajectory) {
  const id = getServoIdForKinematicArm(trajectory, 'A')
  return resolveServoNameForId(id, trajectory.config?.servoVersions) || '舵机A(左)'
}

export function getServoBLabel(trajectory) {
  const id = getServoIdForKinematicArm(trajectory, 'B')
  return resolveServoNameForId(id, trajectory.config?.servoVersions) || '舵机B(右)'
}

/** 卡片上每路物理舵机：舵机号、位置名称、对应运动学 A/B 臂及左右含义 */
export function trajectoryServoBindingLines(trajectory) {
  if (!trajectory?.servos?.length) return []
  return trajectory.servos.map((servo, idx) => {
    const letter = getPhysicalServoKinematicArmLetterFromTrajectory(trajectory, idx)
    const hint = kinematicArmLetterHint(letter)
    return `舵机${servo.s}「位置：${servo.name}」→ ${letter}臂（${hint}）`
  })
}

export function physicalServoArmCaption(trajectory, idx) {
  const letter = getPhysicalServoKinematicArmLetterFromTrajectory(trajectory, idx)
  return `${letter}臂（${kinematicArmLetterHint(letter)}）`
}
